import loadable from "@loadable/component";
import StatusIcon from "../../../Icons/StatusIcon";

const ReferenceTypeListComponent = loadable(
  () => import("../../../components/Settings/ReferenceType/ReferenceTypeList")
);

const ReferenceTypeList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Reference Type</span>
      </div>
      <ReferenceTypeListComponent />
    </>
  );
};



export default ReferenceTypeList
